// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"522":"235d134c","582":"acd9d491"}[chunkId] + ".chunk.css";
};